import { apiVersion } from '../apis.const';
import { transformResponse } from '../apis.util';
import { baseApi } from '../base.api';

/**
 * Create APIs
 */
export const zoneCategoriesApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchZoneCategories: build.query<FetchZoneCategoriesRes, FetchZoneCategoriesReq>({
      query: ({ orgSlug }) => ({
        url: `/${orgSlug}/${apiVersion}/zone/categories`,
      }),
      transformResponse,
      providesTags: ['ZoneCategories'],
    }),

    fetchBuildingZoneCategories: build.query<FetchBuildingZoneCategoriesRes, FetchBuildingZoneCategoriesReq>({
      query: ({ orgSlug, buildingId }) => ({
        url: `/${orgSlug}/${apiVersion}/building/${buildingId}/zone/categories`,
      }),
      transformResponse,
    }),

    createZoneCategory: build.mutation<CreateZoneCategoryRes, CreateZoneCategoryReq>({
      query: ({ orgSlug, ...rest }) => ({
        url: `/${orgSlug}/${apiVersion}/zone/category`,
        method: 'POST',
        body: rest,
      }),
      transformResponse,
      invalidatesTags: ['ZoneCategories'],
    }),

    updateZoneCategory: build.mutation<UpdateZoneCategoryRes, UpdateZoneCategoryReq>({
      query: ({ orgSlug, id, ...rest }) => ({
        url: `/${orgSlug}/${apiVersion}/zone/category/${id}`,
        method: 'PUT',
        body: rest,
      }),
      transformResponse,
      invalidatesTags: ['ZoneCategories'],
    }),

    deleteZoneCategory: build.mutation<DeleteZoneCategoryRes, DeleteZoneCategoryReq>({
      query: ({ orgSlug, id }) => ({
        url: `/${orgSlug}/${apiVersion}/zone/category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ZoneCategories'],
    }),
  }),
});

/**
 * Hooks
 */
export const {
  useFetchZoneCategoriesQuery,
  useFetchBuildingZoneCategoriesQuery,
  useCreateZoneCategoryMutation,
  useUpdateZoneCategoryMutation,
  useDeleteZoneCategoryMutation,
} = zoneCategoriesApi;

/**
 * Types
 */
type OrgSlug = {
  orgSlug: string;
};
export type ZoneCategory = {
  category: string;
  target_interval: string;
  target_frequency: number;
};

type FetchZoneCategoriesRes = Array<ZoneCategory & { id: number }>;
type FetchZoneCategoriesReq = OrgSlug;
type FetchBuildingZoneCategoriesRes = any;
type FetchBuildingZoneCategoriesReq = OrgSlug & {
  buildingId: number;
};
type CreateZoneCategoryRes = any;
type CreateZoneCategoryReq = OrgSlug & ZoneCategory;
type UpdateZoneCategoryRes = any;
type UpdateZoneCategoryReq = OrgSlug &
  ZoneCategory & {
    id: number;
  };
type DeleteZoneCategoryRes = any;
type DeleteZoneCategoryReq = OrgSlug & {
  id: number;
};
